import l1 from './1.png';
import l2 from './2.png';
import l3 from './3.png';
import l4 from './4.png';
import l5 from './5.png';
import l6 from './6.png';
import l7 from './7.png';
import l8 from './8.png';
import l9 from './9.png';
import l10 from './10.png';

export default [l1, l2, l3, l4, l5, l6, l7, l8, l9, l10];